import React from "react";
import { StyleSheet, View, Text, Platform } from "react-native";
import i18n from "i18n-js";
import DropDownPicker from "react-native-dropdown-picker";
import { useTheme } from "@react-navigation/native";
import { CustomTheme } from "../../../../styles/theme.style";
import commonStyles from "../../../../styles/common.style";
import * as GlobalTypes from "../../../../types/GlobalTypes";
import { effects } from "../../../constants/Effects";
import { TableDispatchContext, TableStateContext } from "../../../reducers/table/Context";
import { AppDispatchContext, AppStateContext } from "../../../reducers/app/AppContext";
import { InitialTableState, Action } from "../../../reducers/table/Reducer";
import { DropDownType } from "../../../reducers/app/AppReducer";

interface IEffectsProps {
  tableState: GlobalTypes.TableState.In_Game | GlobalTypes.TableState.Idle;
  heading: string;
}

export default function Effects({ tableState, heading }: IEffectsProps): JSX.Element {
  const { appColors }: CustomTheme = useTheme() as CustomTheme;
  const tableConfig: InitialTableState = React.useContext(TableStateContext);
  const dispatch = React.useContext(TableDispatchContext);
  const appDispatch = React.useContext(AppDispatchContext);
  const appState = React.useContext(AppStateContext);
  const stateConfiguration = tableConfig.configuration_per_state[tableState];
  const [open, setOpen] = React.useState(false);

  //controller for dropdown picker
  const controller = React.useRef(null);

  const allowedEffects = tableConfig.configuration_per_state[tableState].allowed_effects

  //reset the selected item and select the first in the list, if the currently selected item is not allowed anymore
  if (stateConfiguration.default_effect.type && !allowedEffects.includes(stateConfiguration.default_effect.type)) {
    const firstEffect = allowedEffects[0];
    if (firstEffect !== 0) {
      if (controller.current) {
        controller.current.reset();
        controller.current.selectItem(firstEffect);
      }
    }
  }

  //set open manually to false so the zIndex will be correct if the dropdown gets closed, because another gets opened
  appState.openedDropDown !==
    (tableState === GlobalTypes.TableState.Idle ?
      DropDownType.Default_Effect_Idle : DropDownType.Default_Effect_In_Game)
    && controller && controller.current && setOpen(false);

  //filter items to only show allowed items
  const items = effects[tableState].selectableEffects.filter((effect) => allowedEffects.includes(effect.effectType)).map((selectableEffect) => {
    return {
      value: selectableEffect.effectType ? selectableEffect.effectType : 0,
      label: selectableEffect.label ? i18n.t(`Effects.${selectableEffect.label}`) : "",
    };
  })

  return (
    <View
      style={[
        styles.container,
        {
          // for dropdown to be over the other elements
          ...(Platform.OS !== "android" && {
            zIndex: open === true ? 11 : 10, //higher zIndex when open, so always above other dropdowns
          }),
        },
      ]}
    >
      <Text style={[appColors.text, commonStyles.textLeft, styles.marginLeft]}>{heading}</Text>
      <View style={styles.setMaximumBrightnessContainer}>
        <View style={styles.dropDownContainer}>
          <DropDownPicker
            //create dropdown effects for the table state
            items={items}
            controller={instance => controller.current = instance}
            onOpen={() => {
              setOpen(true);
              appDispatch({
                type: "SET_OPENED_DROPDOWN", dropDownType: tableState === GlobalTypes.TableState.Idle ?
                  DropDownType.Default_Effect_Idle : DropDownType.Default_Effect_In_Game
              })
            }}
            isVisible={appState.openedDropDown ===
              (tableState === GlobalTypes.TableState.Idle ?
                DropDownType.Default_Effect_Idle : DropDownType.Default_Effect_In_Game)
              ? true : false}
            onClose={() => setOpen(false)}
            // if type exists, use the type from the config as the default type
            defaultValue={
              (Object.keys(GlobalTypes.Effect) as string[]).includes(`${stateConfiguration?.default_effect.type}`)
                ? stateConfiguration?.default_effect.type
                : console.error("Failed to select the default effect: " + stateConfiguration?.default_effect.type)
            }
            zIndex={tableState === GlobalTypes.TableState.In_Game ? 4000 : 6000}
            zIndexInverse={tableState === GlobalTypes.TableState.In_Game ? 3000 : 1000}
            containerStyle={styles.dropDownContainerStyle}
            style={{ backgroundColor: "#fafafa" }}
            itemStyle={{
              justifyContent: "flex-start",
            }}
            onChangeItem={(item) => {

              const action: Action =
                tableState === GlobalTypes.TableState.Idle
                  ? {
                    type: "SET_DEFAULT_EFFECT_IDLE",
                    effectType: item.value,
                  }
                  : {
                    type: "SET_DEFAULT_EFFECT_IN_GAME",
                    effectType: item.value,
                  };
              console.log(action);
              setOpen(false);
              dispatch(action);
              appDispatch({
                type: "SET_OPENED_DROPDOWN", dropDownType: DropDownType.None
              })
            }}
            //placeholder="Select an effect"
            dropDownStyle={{ backgroundColor: "#fafafa" }}
          />
        </View>
        {/*<View style={styles.saveButtonContainer}>
          <Button
            onPress={() => {
              return;
            }}
            title="Save"
          >
            Save
          </Button>
          </View> */}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    //justifyContent: "center",
    alignItems: "center",
    maxHeight: 100,
    minHeight: 100,
    //maxWidth: 400,
    marginLeft: "1%",
    width: "100%",
    ////marginTop: "2%",
  },
  setMaximumBrightnessContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    width: "90%",
  },
  dropDownContainer: {
    flex: 3,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "1%",
  },
  marginLeft: {
    marginLeft: "1%",
  },
  dropDownContainerStyle: {
    height: 40,
    minWidth: "100%",
  },
});
